<template lang="pug" src="./get-started.pug"></template>

<script>
import Loader from 'components/loader/loader'
import HeroImage from 'components/hero/hero-image/hero-image'
import CustomStartedIntro from 'components/custom/custom-started-intro/custom-started-intro'
import CustomStartedAppointment from 'components/custom/custom-started-appointment/custom-started-appointment'
import CustomStartedForm from 'components/custom/custom-started-form/custom-started-form'
import CustomStartedFinance from 'components/custom/custom-started-finance/custom-started-finance'
import CustomStartedBanner from 'components/custom/custom-started-banner/custom-started-banner'

export default {
  computed: {
    props () {
      return this.$store.state.pages['get-started']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    HeroImage,
    CustomStartedIntro,
    CustomStartedAppointment,
    CustomStartedForm,
    CustomStartedFinance,
    CustomStartedBanner
  }
}
</script>



// WEBPACK FOOTER //
// get-started.vue?b4f757f6